import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/config";

const AccountDetails = () => {
  const [user, setUser] = useState({
    name: "",
    email: "",
    contact: "",
  });

  const [newPassword, setNewPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const token = sessionStorage.getItem("authToken");

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.post(
          `${BASE_URL}/user`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = res.data.data;
        setUser({
          name: data.firstName,
          email: data.email,
          contact: data.phoneNo,
        });
      } catch (error) {
        setMessage("❌ Failed to fetch user details");
      }
    };
    fetchUser();
  }, [token]);

  const handlePasswordChange = async () => {
    if (newPassword !== confirmPassword) {
      setMessage("❌ Passwords do not match.");
      return;
    }

    try {
      const res = await axios.post(
        `${BASE_URL}/updateUser`,
        {
          password: currentPassword,
          newPassword,
          email: user.email,
          phone: user.contact,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMessage(`✅ ${res.data.message}`);
      setNewPassword("");
      setConfirmPassword("");
      setCurrentPassword("");
    } catch (error) {
      setMessage(`❌ ${error.response?.data?.message || "Update failed"}`);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body">
          <h4 className="mb-3 text-primary">Account Details</h4>

          <div className="row">
            <div className="mb-3 col-lg-6 col-sm-12">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                value={user.name}
                disabled
              />
            </div>

            <div className="mb-3 col-lg-6 col-sm-12">
              <label className="form-label">Contact No</label>
              <input
                type="text"
                className="form-control"
                value={user.contact}
                onChange={(e) => setUser({ ...user, contact: e.target.value })}
              />
            </div>

            <div className="mb-3 col-12">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                className="form-control"
                value={user.email}
                onChange={(e) => setUser({ ...user, email: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h4 className="mb-3 text-danger">Password Change</h4>

          <div className="mb-3">
            <label className="form-label">Current Password</label>
            <input
              type="password"
              className="form-control"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          {message && (
            <div className="alert alert-info mt-3" role="alert">
              {message}
            </div>
          )}

          <button
            className="btn btn-dark fw-bold mt-2"
            onClick={handlePasswordChange}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
